import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { hudPackageApiCRUDUrl } from '../../constants/apis/hud_apis';

export const getHudPatientDoses = async (packageId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPackageApiCRUDUrl + packageId + "/doses/", config);
    return response;
};

export const addHudPatientDoses = async (packageId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPackageApiCRUDUrl + packageId + "/add-dose/", data, config);
    return response;
};

export const updateHudPatientDoses = async (packageId, doseId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", data, config);
    return response;
};

export const addHudPatientPackageDoseComment = async (packageId, doseId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/add-comment/", data, config);
    return response;
};

export const deleteHudPatientPackageDose = async (packageId, doseId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(hudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", config);
    return response;
};

export const patchHudPatientPackageDose = async (packageId, doseId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", data, config);
    return response;
};